import { DefaultRootState } from "react-redux";

import { createSelector } from "@reduxjs/toolkit";

import { QuickFiltersState } from "../../reducers/quickFilters";

export const getQuickFiltersSelector = createSelector(
  (state: DefaultRootState) => state.qucikFilters,
  ({ quickFilter, quickFiltersCategories, isLoading }: QuickFiltersState) => ({
    quickFilter,
    quickFiltersCategories,
    isLoading,
  }),
);

export const getCategoriesFilterButtons = createSelector(
  (state: DefaultRootState) => state.qucikFilters,
  ({ categoriesFilterButtons }: QuickFiltersState) => categoriesFilterButtons,
);
